import Container from "@mui/material/Container";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <Container key={component.id} />;
}

export default Component;
